import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { inject } from "mobx-react";

import { Button, Modal, Toastr, Utils } from "arv-reactcomponents";
import { isDesktop, fbInit } from "../../../utils";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import { FB_SHARE_TITLE } from "../../../constants";

@inject("ProductStore")
class PdpShare extends Component {
  constructor() {
    super();
    this.state = {
      shareModalOpen: false,
      isFbDisabled: true,
      copyDisabled: false,
      shortenedUrl: window.location.href,
    };
    this.urlShortenerCalled = false;
    this.toggleShare = this.toggleShare.bind(this);
    this.setFb = this.setFb.bind(this);
    this.fbShare = this.fbShare.bind(this);
    this.linkShareTwitter = this.linkShareTwitter.bind(this);
    this.linkSharePinterest = this.linkSharePinterest.bind(this);
    this.copyLink = this.copyLink.bind(this);
    this.getUrlShortened = this.getUrlShortened.bind(this);
    this.shareGAEvent = this.shareGAEvent.bind(this);
    this.shareHover = this.shareHover.bind(this);
  }
  componentDidMount() {
    fbInit(this.setFb);
  }

  get twitterShare() {
    return `https://twitter.com/intent/tweet?url=${
      this.state.shortenedUrl
    }&text=${this.props.brandName}-${this.props.name}`;
  }
  get pinterestShare() {
    const image =
      this.props.images && this.props.images[0] && this.props.images[0].medium;
    return `http://pinterest.com/pin/create/button/?url=${
      this.state.shortenedUrl
    }&description=${document.title}&media=${image}`;
  }

  setFb() {
    this.setState({ isFbDisabled: false });
  }
  getUrlShortened() {
    if (this.urlShortenerCalled) {
      return null;
    }
    const body = JSON.stringify({ longUrl: window.location.href });
    this.props.ProductStore.urlShortener(body).then(response => {
      this.urlShortenerCalled = true;
      const shortenedUrl = response.id;
      this.setState({ shortenedUrl });
    });
    return null;
  }
  shareHover() {
    if (isDesktop) {
      this.getUrlShortened();
      Analytics.trackEvent({
        action: Event.action.SHARE_HOVER,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });
    }
  }
  /* eslint-disable class-methods-use-this */
  shareGAEvent(channel) {
    Analytics.trackEvent({
      action: Event.action.SHARE_SELECTED,
      label: Event.label.getShareType(channel),
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
  }
  toggleShare() {
    if (!isDesktop) {
      this.getUrlShortened();
      const flag = this.state.shareModalOpen;
      this.setState({ shareModalOpen: !flag });
      const shareModal = !flag
        ? Event.action.SHARE_CLICK
        : Event.action.SHARE_CLOSE;
      Analytics.trackEvent({
        action: shareModal,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });
    }
  }
  fbShare() {
    const image =
      this.props.images && this.props.images[0] && this.props.images[0].medium;
    const desc =
      document.querySelector("meta[name='description']") &&
      document
        .querySelector("meta[name='description']")
        .getAttribute("content");
    if (window.FB) {
      window.FB.ui({
        method: "share",
        href: this.state.shortenedUrl,
        title: document.title,
        picture: image,
        caption: FB_SHARE_TITLE,
        description: desc,
      });
      this.shareGAEvent("fb");
    } else {
      console.log("fb not supported");
    }
  }
  copyLink() {
    try {
      const inp = document.createElement("input");
      document.body.appendChild(inp);
      inp.value = window.location.href;
      inp.select();
      document.execCommand("copy", false);
      inp.remove();
      Toastr.showToastr({
        className: "nwc-toastr-list-notification nw-toastr",
        message: "Link Copied",
        timeout: 3000,
      });
      this.toggleShare();
    } catch (err) {
      this.setState({ copyDisabled: true });
    }
  }

  linkShareTwitter() {
    this.shareGAEvent("twitter");
  }

  linkSharePinterest() {
    this.shareGAEvent("pinterest");
  }
  render() {
    return (
      <Fragment>
        <div
          onMouseEnter={this.shareHover}
          className="nw-pdpdetails-share-enclose"
        >
          <div
            role="button"
            className="nwc-btn nw-pdpdetails-share nw-pdpdetails-icons"
            onClick={this.toggleShare}
            onKeyDown={Utils.noop}
            tabIndex={0}
          >
            <i className="icomoon-share nw-pdpshare-icon" />
          </div>
          <div className="nw-pdpdetails-shareicons">
            <Button
              className={`nw-pdpdetails-fbshare ${
                this.state.isFbDisabled ? "nwc-hide" : ""
              }`}
              onClick={this.fbShare}
            >
              <i className="icomoon-facebook" />
            </Button>
            <a
              href={this.twitterShare}
              target="_blank"
              className="nw-pdpdetails-twittershare"
              onClick={this.linkShareTwitter}
            >
              <i className="icomoon-twitter" />
            </a>
            <a
              href={this.pinterestShare}
              target="_blank"
              className="nw-pdpdetails-pinterestshare"
              onClick={this.linkSharePinterest}
            >
              <i className="icomoon-pinterest" />
            </a>
          </div>
        </div>
        <Modal
          className="nw-pdpdetails-sharemobile"
          isOpen={this.state.shareModalOpen}
          onClose={this.toggleShare}
        >
          <div className="nw-pdpdetails-sharemobile-enclose">
            <div
              role="button"
              className={`nwc-btn nw-pdpdetails-sharemobileitem ${
                this.state.isFbDisabled ? "disabled" : ""
              }`}
              onClick={this.fbShare}
              tabIndex="0"
              onKeyPress={Utils.noop}
            >
              <i className="icomoon-facebook fb nw-pdpdetails-sharemobilelogo" />
              <span className="nw-pdpdetails-fbsharemobiletext">FACEBOOK</span>
            </div>
            <a
              href={this.twitterShare}
              target="_blank"
              className="nw-pdpdetails-sharemobileitem"
              onClick={this.linkShareTwitter}
            >
              <i className="icomoon-twitter twitter  nw-pdpdetails-sharemobilelogo" />
              <span className="nw-pdpdetails-fbsharemobiletext">TWITTER</span>
            </a>
            <a
              href={this.pinterestShare}
              target="_blank"
              className="nw-pdpdetails-sharemobileitem"
              onClick={this.linkSharePinterest}
            >
              <i className="icomoon-pinterest pinterest  nw-pdpdetails-sharemobilelogo" />
              <span className="nw-pdpdetails-fbsharemobiletext">PINTEREST</span>
            </a>
            <div
              role="button"
              className={`nwc-btn nw-pdpdetails-sharemobileitem ${
                this.state.copyDisabled ? "disabled" : ""
              }`}
              onClick={this.copyLink}
              disabled={this.state.copyDisabled}
              tabIndex="0"
              onKeyPress={Utils.noop}
            >
              <i className="icomoon-copy copy  nw-pdpdetails-sharemobilelogo" />
              <span className="nw-pdpdetails-fbsharemobiletext">COPY LINK</span>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

PdpShare.defaultProps = {
  brandName: "",
  name: "",
  images: [],
};

PdpShare.propTypes = {
  ProductStore: PropTypes.shape({
    urlShortener: PropTypes.func.isRequired,
  }).isRequired,
  brandName: PropTypes.string,
  name: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      medium: "",
    }),
  ),
};
export default PdpShare;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/PdpShare/index.js